<template>
    <div>
        <div v-if="to_user">
            <div class="chatList" v-infinite-scroll="load" style="overflow:auto">
                <el-checkbox-group v-model="checkList">
                    <el-checkbox :label="o.id" v-for="(o,i) in piclist" :key="i">
                        <div>
                            {{o.name}}
                        </div>
                    </el-checkbox>
                </el-checkbox-group>
            </div>
            <div class="btns">
                <el-button class="btn" size="small" @click="sendwz" type="primary">发送</el-button>
            </div>
        </div>
        <div v-else class="sele_user">
            请选择用户
        </div>
    </div>
</template>

<script>
    import {
        mapState
    } from 'vuex'

    export default {
        name: "chatList",
        props: ['to_user'],

        data() {
            return {
                count: 0,
                page: 1,
                piclist: [],
                checkList: []
            }
        },
        watch: {

        },
        computed: {
            ...mapState({
                user: state => state.user.user,
            }),
        },
        mounted() {},
        created() {},
        methods: {
            load() {
                this.getList()

            },
            getList() {
                let user = JSON.parse(sessionStorage.getItem('doc_data'))
                axios.post('/admin/getMyHeadlines', {
                    page: this.page,
                    page_count: 20,
                    type: "1",
                    user_id: user.id,
                }, {
                    token: true
                }).then(res => {
                    let data = res.data.data.list
                    if (data && data.length > 0) {
                        this.piclist = this.piclist.concat(data)
                        this.page++
                    } else {

                    }
                }).catch((error) => {
                    console.log(error);
                    // this.loading = false;
                })
            },

            sendwz() {
                if (this.checkList.length == 0) return this.$message.error('请选择要分享的文章')
                for (let v of this.piclist) {
                    if (this.checkList.indexOf(v.id) != -1) {
                        let arr={
                            id: v.id,
                            name: v.name,
                            content: v.content.substr(0, 50),
                            img: v.file[0].url,
                            type:'wz'
                        }
                        this.$nextTick(()=>{
                             this.$parent.on.send(JSON.stringify(arr)) 
                        })
                      
                    }
                }
            },
        },
        destroyed() {}
    }
</script>

<style lang="scss" scoped>
    .chatList {
        // width: 100%;
        height: 707px;
        padding: 10px;
        border-right: 1px solid #ECECEC;
    }

    .btns {
        display: flex;
        justify-content: center;
        padding: 3px 0;

        .btn {
            padding: 9px 25px;
        }
    }

    .sele_user {
        text-align: center;
        padding: 10px;
        color: #999;

    }
</style>